import { Grid, Skeleton } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';

// Our Components
import HighlightCards from 'components/FADashboard/HighlightCarousel/HighlightCards';

// Our Hooks
import useGetFaTotalLiabilities from 'hooks/advisorDashboard/useGetFaTotalLiabilities';

// our Selectors
import selectHighlightCardData from 'selectors/faSummary/selectHighlightCardData';

function HighlightCardsSkeleton() {
	return (
		<Grid item xs={4}>
			<Skeleton
				variant="rectangular"
				sx={{
					height: 180,
					borderRadius: 2,
					width: '100%'
				}}
			/>
		</Grid>
	);
}

function HighlightCardsSection() {
	const {
		data: totalLoans,
		isLoading,
		isSuccess
	} = useGetFaTotalLiabilities(selectHighlightCardData);

	const loadingCards = Array.from({ length: 3 }, (_, index) => (
		<HighlightCardsSkeleton key={uuidv4()} />
	));

	if (isLoading) {
		return (
			<Grid
				container
				item
				xs={12}
				columnSpacing={3}
				sx={{ marginBottom: 6, paddingRight: 4 }}
			>
				{loadingCards}
			</Grid>
		);
	}

	if (isSuccess) {
		return (
			<Grid
				container
				item
				xs={12}
				columnSpacing={3}
				sx={{ marginBottom: 6, paddingRight: 4 }}
			>
				<HighlightCards totalLoansUnderManagement={totalLoans} />
			</Grid>
		);
	}
}

export default HighlightCardsSection;
